import * as React from 'react';
import { InjectedTranslatedProps, translate } from 'react-i18next';
import { Button } from 'wix-ui-tpa/Button';
import styles from './GroupList.st.css';
import { GroupListItem } from '../GroupListItem';
import withGroups, { WithGroupsProps } from '../../contexts/withGroups';

export interface GroupListProps {
  onCreateGroupClick(): void;
  goToGroup(): void;
}

export const GroupListComponent: React.FC<
  GroupListProps & InjectedTranslatedProps & WithGroupsProps
> = props => {
  const { t, onCreateGroupClick, goToGroup, groups, ...restProps } = props;
  let content;
  if (!groups) {
    content = <div>Loading...</div>;
  } else if (!groups.length) {
    content = (
      <div>
        <h2>{t('groups-web.empty-state.header')}</h2>
        <p>{t('groups-web.empty-state.text')}</p>
        <Button
          onClick={onCreateGroupClick}
          data-hook="empty-state-create-group-button"
        >
          {t('groups-web.empty-state.cta')}
        </Button>
      </div>
    );
  } else {
    content = (
      <>
        {groups.map(group => {
          return (
            <GroupListItem
              key={group.groupId}
              group={group}
              goToGroup={goToGroup}
              data-hook="group-list-item"
            />
          );
        })}
      </>
    );
  }

  return <div {...styles(styles.root, {}, restProps)}>{content}</div>;
};

export const GroupList = withGroups(
  translate()(GroupListComponent),
) as React.ComponentType<GroupListProps>;
